import { createStore, applyMiddleware, compose  } from "redux";
import rootReducer from "./Reducers";
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'

const loggerMiddleware = createLogger()

const store = createStore(rootReducer, 
    compose(
        applyMiddleware(
            thunkMiddleware, // lets us dispatch() functions
            loggerMiddleware // neat middleware that logs actions
        ),
        //https://stackoverflow.com/a/55881955
        window.__REDUX_DEVTOOLS_EXTENSION__
            ? window.__REDUX_DEVTOOLS_EXTENSION__()
            : f => f
    )
);

export default store;


// WEBPACK FOOTER //
// ./src/redux/Store.jsx